import { ActionType } from '../../constants/ActionTypes'
import config from '../../constants/Configs'

import { RestPath } from '../../constants/SitePaths'
import { Constants } from '../../constants/Constants'
import axios from 'axios';


/* SEO SCHEMA SETTINGS */
export const getSeoSchemaBegin = (data) => ({
    type: ActionType.GET_SEO_SCHEMA_BEGIN,
    payload: data
});

export const getSeoSchemaError = (data) => ({
    type: ActionType.GET_SEO_SCHEMA_ERROR,
    payload: data
});

export const getSeoSchemaSuccess = (lang, data) => ({
    type: ActionType.GET_SEO_SCHEMA_SUCCESS,
    payload: {
        lang: lang,
        data: data
    }
});


/** Get SEO Settings */
export function getSeoSchema(lang) {
    return dispatch => {

        dispatch(getSeoSchemaBegin());
        return    axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.GET_SEO_SCHEMA}`
            }).then((response) => {
                dispatch(getSeoSchemaSuccess(lang, response.data));
            })
            .catch((error) => {
                if(error.response){
                    dispatch(getSeoSchemaError(error.response.data));
                }else{
                    dispatch(getSeoSchemaError(error));
                }
               
                
            });
    };
}